__turbopack_context__.v({
  "back": "deep-dive-header-module__lsb_Ja__back",
  "chip": "deep-dive-header-module__lsb_Ja__chip",
  "chips": "deep-dive-header-module__lsb_Ja__chips",
  "clear": "deep-dive-header-module__lsb_Ja__clear",
  "count": "deep-dive-header-module__lsb_Ja__count",
  "root": "deep-dive-header-module__lsb_Ja__root",
  "row": "deep-dive-header-module__lsb_Ja__row",
  "sort": "deep-dive-header-module__lsb_Ja__sort",
  "title": "deep-dive-header-module__lsb_Ja__title",
  "top": "deep-dive-header-module__lsb_Ja__top",
});
